import React, { Component } from 'react';
import { Row, Col, Container } from "reactstrap";
import { Link } from "react-router-dom";

export default class ContainerItem extends Component {
    constructor(props) {
        super(props);
        this.container = this.props.container;
        this.filtros = this.props.filtros;
    }

    situacaoCss = (situacao) => situacao.toLowerCase().replace(/\s|\./g, '-').replace('--', '-')

    render() {
        return (
            <div className="container-item p-3 d-flex">
                <Container>
                    <Row className="mb-1">
                        <Col><span className="Cntr">{this.container.Cntr}</span></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><span >{this.container.PortoEmbarque}</span></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col className="box mr-1 py-2">
                            <Row>
                                <Col><span className={'font-weight-bold'}>ARMADOR</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.container.Armador}</span></Col>
                            </Row>
                        </Col>
                        <Col className="box ml-1 py-2">
                            <Row>
                                <Col><span className={'font-weight-bold'}>TIPO</span></Col>
                            </Row>
                            <Row>
                                <Col><span>{this.container.Tipo}</span></Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col className="px-0">
                            {
                                <span className={"situacao " + this.situacaoCss(this.container.Situacao)} dangerouslySetInnerHTML={{ __html: (this.container.Situacao.concat((this.container.Situacao.toUpperCase() === "AGENDADO PARA" && this.container.AgendCntr) ? ' <b>' + this.container.AgendCntr + '</b>' : '')) }}></span>
                            }
                        </Col>
                    </Row>   
                    {process.env.rig && this.container.Situacao.toUpperCase() === "AGENDADO PARA" ?
                        <React.Fragment>
                            <Row className="mb-2">
                                <Col className="px-0">
                                    <span className={"status-nf-ade nota-" + this.container.NotaCntr.toLowerCase()} dangerouslySetInnerHTML={{ __html: 'Nota Fiscal ADE ' + ((this.container.NotaCntr.toLowerCase() === 'f') ? '<b>não</b>' : '') + ' cadastrada' }} ></span>
                                </Col>
                            </Row>
                        </React.Fragment> : <React.Fragment />
                    }
                    <Row>
                        <Col className="d-flex align-items-end flex-column" >
                            <Link to={{
                                pathname: `/containers-detalhes/${this.container.Cntr}`,
                                state: {
                                    container: this.filtros.container,
                                    booking: this.filtros.booking,
                                    notafiscal: this.filtros.notaFiscal
                                }
                            }}
                            >
                                <b>
                                    VER DETALHES
                                </b>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/ContainerItem.js